import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowAuthGrant = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "auth_grant":
        if (permission.isOtherReadable()) {
          return true;
        }
        break;
      default:
        break;
    }
  }
  return false;
};
